var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 46,
    viewBox: "0 0 70 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.455 32.68C42.105 33.79 42.5 35.065 42.5 36.44C42.5 40.58 39.145 43.94 35 43.94C30.855 43.94 27.5 40.58 27.5 36.44C27.5 32.3 30.855 28.94 35 28.94C35.375 28.94 35.73 28.995 36.09 29.05L56.24 3.885L57.89 4.92L41.455 32.68ZM35 5C38.22 5 41.31 5.535 44.22 6.485C44.44 6.555 46.72 6.955 47.58 5C48.395 3.145 46.715 2.025 46.02 1.79C42.55 0.635 38.855 0 35 0C15.67 0 0 15.67 0 35C0 38.235 0.475 41.355 1.3 44.33C1.3 44.33 2.74 46.535 4.925 45.405C6.73 44.465 6.135 43.15 5.98 42.55C5.34 40.135 5 37.61 5 35C5 18.455 18.455 5 35 5ZM59.69 14.14C58.205 15.625 59.34 17.53 59.475 17.73C62.94 22.62 65 28.57 65 35C65 37.85 64.59 40.605 63.85 43.215C63.74 43.59 63.855 45.57 65.47 45.895C67.925 46.395 68.7 44.335 68.7 44.335C69.525 41.355 70 38.235 70 35C70 27.31 67.52 20.205 63.31 14.44C62.855 13.815 60.79 13.035 59.69 14.14Z",
    fill: "#F6CA4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.b871056e01083afc2fe3552c1b24ac31.svg";
export { ForwardRef as ReactComponent };